import {
  createFileRoute,
  isMatch,
  Outlet,
  useMatches,
} from "@tanstack/react-router"
import { useTranslation } from "react-i18next"

import Heading from "@/globalComponents/atoms/Heading"
import { Crumb } from "@/utilities/types/local"

export const Route = createFileRoute("/_authenticated/account")({
  component: RouteComponent,
  loader: () => {
    return { crumb: { translationKey: "account.title" } as Crumb }
  },
})

function RouteComponent() {
  const { t } = useTranslation()

  const matches = useMatches()

  if (matches.some((match) => match.status === "pending")) return <Outlet />

  const matchesWithCrumbs = matches.filter((match) =>
    isMatch(match, "loaderData.crumb")
  )

  const key =
    matchesWithCrumbs[matchesWithCrumbs.length - 1].loaderData?.crumb
      .translationKey

  return (
    <>
      {key && (
        <Heading className="center" level={3} as={1}>
          {t(key)}
        </Heading>
      )}
      <Outlet />
    </>
  )
}
